import type { ITabsProps } from './Tabs'

import { styled } from '@linaria/react'
import { TabBaseSC } from 'atoms/Tab'
import { BORDERS, COLOR, FIXED_INDENTS } from 'vars/index'

export const TabsList = styled.div<
  Omit<ITabsProps, 'list' | 'title' | 'nodeRef'> & {
    countChildren: number
  }
>`
  overflow-x: auto;
  display: flex;
  flex-wrap: nowrap;
  scroll-behavior: smooth;
  gap: ${({ gap = FIXED_INDENTS.INDENT_80 }) => `var(${gap})`};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  border-width: ${({ borderWidth = BORDERS.BORDER_0 }) =>
    `var(${borderWidth})`};
  border-style: solid;
  border-color: ${({ borderColor = COLOR.TRANSPARENT }) =>
    `var(${borderColor})`};
  width: ${({ isFixedWidthTabs }) => (isFixedWidthTabs ? '100%' : 'auto')};

  > * {
    scroll-snap-align: start;
  }

  > a {
    min-width: fit-content;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none; // for Mozilla Firefox

  ${TabBaseSC} {
    min-width: ${({
      isFixedWidthTabs,
      gap = FIXED_INDENTS.INDENT_80,
      countChildren,
    }) =>
      isFixedWidthTabs
        ? `calc((100% - (var(${gap}) * (${countChildren} - 1))) / ${countChildren})`
        : 'fit-content'};
    justify-content: center;
    align-items: center;

    &:first-child {
      margin-left: 0;
    }
  }
`
